module.exports = __webpack_public_path__ + "static/media/fly0058.b4da7441.webp";